import React from 'react'
import { Form } from "react-bootstrap";
import { ArrowLeft } from "lucide-react";
import { ArrowRight } from "lucide-react";

const DomainQuestion = ({formState,handleDomainChange,showError,setFormState,setStep,step,nextdomain}) => {
  return (
    <Form>
    <div className="new-font mb-4">
      <h3 className="h5 mb-3">Select Domain</h3>
      <Form.Select
        value={formState.selectedDomain}
        onChange={handleDomainChange}
        required
      >
        <option value="">Select a domain</option>
        {formState.domainData.map((domain) => (
          <option
            key={domain.id}
            value={domain.id}
            className="body-font"
          >
            {domain.fields.Domain_name}
          </option>
        ))}
      </Form.Select>
    </div>
    {showError && (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ color: "red" }}
      >
        ** {showError} **
      </div>
    )}
    <div className="d-flex align-items-center justify-content-center gap-2">
      <button
        style={{
          backgroundColor: "#e0e0e4",
        }}
        className="w-100 py-2 rounded mt-4 text-black hover-btn"
        onClick={() => {
          setFormState((prev) => ({
            ...prev,
            currentStep: "nonDomainQuestions",
          }));
          setStep(step - 1);
        }}
      >
        <ArrowLeft className="ms-3 h-2 w-2 me-2" />
        Back
      </button>
      <button
        className="w-100 py-2 rounded mt-4 border-0 text-white new-btn"
        // type="submit"
        onClick={(e) => nextdomain(e, "filteredQuestions")}
      >
        Next
        <ArrowRight className="ms-3 h-2 w-2" />
      </button>
    </div>
  </Form>
  )
}

export default DomainQuestion